import type { TrackingIntegration } from '@chukua/common';
import { Alert, Button, Popconfirm } from 'antd';
import { FormCardSkeleton } from '../../../../../shared/components/FormCardSkeleton';
import { useAdapterCatalogue } from '../hooks/use-adapter-catalogue';
import { useIntegrationSheet } from '../hooks/use-integration-sheet';
import { IntegrationForm } from './IntegrationForm';

interface GpsIntegrationSettingsProps {
  integration: TrackingIntegration;
  onSaved: (integration: TrackingIntegration) => void;
  onUninstall: () => Promise<void>;
}

/** The Settings tab: the adapter's fields with the saved values (secrets write-only), a connection test, and uninstalling. */
export function GpsIntegrationSettings({ integration, onSaved, onUninstall }: GpsIntegrationSettingsProps) {
  const catalogue = useAdapterCatalogue();
  const sheet = useIntegrationSheet({ catalogue, adapterKey: undefined, integration, onDone: onSaved });

  if (sheet.isLoading) return <FormCardSkeleton label="Loading the settings" />;
  return (
    <div className="flex max-w-xl flex-col gap-8">
      {sheet.adapter ? (
        <IntegrationForm key={integration.id} sheet={sheet} adapter={sheet.adapter} isEdit />
      ) : (
        <Alert type="error" showIcon title="This integration's adapter isn't available" description="It may no longer be part of this release." />
      )}
      <div className="flex flex-col gap-3 border-t border-line pt-5">
        <h3 className="text-sm font-semibold text-fg">Uninstall</h3>
        <p className="text-sm text-muted">Ends every device's truck mapping. Positions already received are kept.</p>
        <div>
          <Popconfirm title={`Uninstall ${integration.displayName}?`} okText="Uninstall" okButtonProps={{ danger: true }} onConfirm={onUninstall}>
            <Button danger>Uninstall {integration.displayName}</Button>
          </Popconfirm>
        </div>
      </div>
    </div>
  );
}
